import { Locale } from 'date-fns'
import { da, de, enUS, fr, nl } from 'date-fns/locale'
import i18next from 'i18next'

export const locales: Record<string, Locale> = {
  da,
  de,
  en: enUS,
  fr,
  nl,
}

// @todo it can be just function (it doesn't use the state)
export const useLocale = (): Locale => {
  return locales[i18next.language] || locales.da
}
